import { MiniBook } from '@shared/domain/orderBook';
import { binanceItemToBookItem } from '@shared/domain/binance';
import binanceApi from '@shared/services/api/binance';

export const binanceUSDMApi = binanceApi.bind(null, 'https://fapi.binance.com');

export type TickerResponse = {
  symbol: CurrencyPair,
  price: CurrencyAmount,
};

export const getTicker = (
  base: Currency,
  counter: Currency,
): Promise<TickerResponse> => (
  binanceUSDMApi(`fapi/v1/ticker/price?symbol=${base}${counter}`)
);

export const getOrderBook = ({
  base,
  counter,
  limit = 20,
}: {
  base: Currency,
  counter: Currency,
  limit?: number,
}): Promise<MiniBook> => (
  binanceUSDMApi(`fapi/v1/depth?limit=${limit}&symbol=${base}${counter}`)
    .then((book) => ({
      asks: book.asks.map(binanceItemToBookItem),
      bids: book.bids.map(binanceItemToBookItem),
    }))
);
